import { OP_STATUSES } from '@common/constants';

export const handleEditSubmit = (
  result,
  setShowEditProject,
  setProjectData,
  onProfileSave
) => {
  setShowEditProject(false);

  if (result.status === OP_STATUSES.SUCCESS) {
    const { response } = result;
    setProjectData(response);
  }

  onProfileSave(result);
};
